import { render, staticRenderFns } from "./singleStockInquiry.vue?vue&type=template&id=098b9845&scoped=true"
import script from "./singleStockInquiry.vue?vue&type=script&lang=js"
export * from "./singleStockInquiry.vue?vue&type=script&lang=js"
import style0 from "./singleStockInquiry.vue?vue&type=style&index=0&id=098b9845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b9845",
  null
  
)

export default component.exports